import $ from 'jquery';
import isMobile from '../util/isMobile';

const BackgroundVideoPlayerHome = {
  el: $('.banner__video'),
  init: () => {
    // a propriedade lazy está iniciando o vídeo automaticamente
  },
  play: () => {
    if (BackgroundVideoPlayerHome.el.attr('src') && !isMobile()) {
      BackgroundVideoPlayerHome.el.get(0).play();
    }
  },
  pause: () => {
    if (BackgroundVideoPlayerHome.el.attr('src') && !isMobile()) {
      BackgroundVideoPlayerHome.el.get(0).pause();
    }
  },
};

export default BackgroundVideoPlayerHome;
